import {
  useEffect, useCallback,
} from 'react';
import { useDispatch } from 'react-redux';

export const useAsyncSubmit = (onAccept, onCancel) => useCallback(async (...args) => {
  const result = await onAccept(...args);
  if (result) {
    onCancel(result);
  }
  return result;
}, [onAccept, onCancel]);

export const useEffectAsync = (asyncFn, deps) => useEffect(() => {
  asyncFn();
// eslint-disable-next-line react-hooks/exhaustive-deps
}, deps);

export const useDispatchCallback = (actionCreator, ...bindArgs) => {
  const dispatch = useDispatch();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback((...args) => dispatch(actionCreator(...bindArgs, ...args)), [dispatch, actionCreator, ...bindArgs]);
};
